import GlobalStyle from './styles/GlobalStyle';
import Main from './views/main.js';
function App() {
  return (
    <>
      <GlobalStyle/>
      <Main/>
    </>
  );
}

export default App;